// Tiny JWT inspection helper. We trust the token (it's already validated
// by the auth service and PostgREST) — this is just for the UI to know
// which navigation/guards to render.

import { supabase } from './supabase';

export interface JwtClaims {
  sub: string;
  email: string;
  tenant_id: string | null;
  app_role: 'super_admin' | 'owner' | 'staff';
}

const decode = (token: string): JwtClaims | null => {
  try {
    const payload = token.split('.')[1];
    const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(json);
  } catch {
    return null;
  }
};

export const getClaims = async (): Promise<JwtClaims | null> => {
  const { data } = await supabase.auth.getSession();
  if (!data.session?.access_token) return null;
  return decode(data.session.access_token);
};
